import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { TooltipProvider } from './components/ui/tooltip';
import App from './App.tsx';
import { LearningAuthProvider } from './contexts/LearningAuth.tsx';
import { UserManager } from 'oidc-client-ts';
import { oidcConfig } from './lib/oidcConfig.ts';

// Clean up any stale OIDC state from previous sessions before the app starts.
// This doesn't need to be awaited.
new UserManager(oidcConfig).clearStaleState();

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <TooltipProvider delayDuration={300}>
        <BrowserRouter>
          <LearningAuthProvider>
            <App />
          </LearningAuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </StrictMode>
  );
}